import { render } from "./CalculatorScaffold.vue?vue&type=template&id=2f8e1427"
import script from "./CalculatorScaffold.vue?vue&type=script&lang=js"
export * from "./CalculatorScaffold.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__